"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
  textAlign: 'center'
});
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link)({
  cursor: 'pointer'
});
